module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921014149_T.a425ad8d.jpg";